import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon, Button, WithTooltip, Input } from '../Elements';

import classes from './TableFilterFromTo.module.scss';

const TableFilterFromTo = ({ fromTo, handleFromTo, field = '' }) => {
  const [isVis, setIsVis] = useState(false);

  const maxValue = fromTo[`to`];
  const minValue = fromTo[`from`];

  const onClearSearch = data => setIsVis(data);

  const text = (
    <div className={classes.filter_tooltip}>
      <Input
        input={{ value: minValue, onChange: handleFromTo }}
        placeholder="From"
        className={classes.filter_tooltip__input}
        name="from"
        type="number"
        field={field}
      />
      <span className={classes.filter_tooltip__minus}>{' - '}</span>
      <Input
        input={{ value: maxValue, onChange: handleFromTo }}
        placeholder="To"
        className={classes.filter_tooltip__input}
        name="to"
        type="number"
        field={field}
      />
      <Button
        className={classes.close}
        onClick={handleFromTo}
        aria-label="clear filter"
        id={field}
        field={field}
      >
        <Icon icon="closeCircle" className={classes.close_icon} size="16px" />
      </Button>
    </div>
  );

  return (
    <WithTooltip
      text={text}
      position="top"
      className={cn(classes.box, classes.box_fix)}
      isVisible={onClearSearch}
    >
      <div className={classes.filter}>
        <Icon
          size="16px"
          icon="filter"
          className={cn(
            classes.filter_icon,
            fromTo[`from`] !== '' || fromTo[`to`] !== '' || isVis
              ? classes.filter_icon__active
              : ''
          )}
        />
      </div>
    </WithTooltip>
  );
};

TableFilterFromTo.propTypes = {
  fromTo: PropTypes.object.isRequired,
  handleFromTo: PropTypes.func.isRequired,
  field: PropTypes.string
};

export default TableFilterFromTo;
